import { AppDispatch } from "../Redux/store";
import { setAuthHydrated, setUserAuth } from "../Redux/reducers/userSlice";

export type EstablishSessionInput = {
  accessToken: string;
  refreshToken: string;
  id: string;
  role: string;
  firstName?: string | null;
  lastName?: string | null;
};

export function establishSession(
  dispatch: AppDispatch,
  data: EstablishSessionInput
) {
  localStorage.setItem("sm-access-token", data.accessToken);
  localStorage.setItem("sm-refresh-token", data.refreshToken);
  localStorage.setItem("user-id", data.id);

  if (data.firstName) {
    localStorage.setItem("first-name", data.firstName);
  }

  if (data.lastName) {
    localStorage.setItem("last-name", data.lastName);
  }

  dispatch(
    setUserAuth({
      authenticated: true,
      role: data.role,
      userId: data.id,
    })
  );
  dispatch(setAuthHydrated(true));
}
